import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";

import { ConfettiIcon } from "../../images/Icons/ConfettiIcon";
import { isDialogOpen, setDialog } from "../../store/slices/global";
import { bestPracticesDuringTest } from "../../utils/linkSheet";
import openNewTab from "../../utils/openNewTab";

export const StartTestDialog = () => {
  const isOpen = useSelector(isDialogOpen("startTest"));
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setDialog({ dialog: "startTest", open: false }));
  };

  return (
    <IgDialog
      title={"Congratulations, your test is live!"}
      dialogImage={<ConfettiIcon sx={{ fontSize: "70px" }} />}
      subtitle={
        <IgTypography>
          Please see our article{" "}
          <IgTypography
            igStyle={"link"}
            onClick={() => {
              openNewTab(bestPracticesDuringTest, "Best Practices During Test");
            }}
          >
            here
          </IgTypography>{" "}
          for best practices to keep in mind while your experiment is live.
        </IgTypography>
      }
      handleClose={handleClose}
      noButtonText={null}
      handleYesClick={handleClose}
      showDialog={isOpen}
      yesButtonText={"Close"}
      dialogHeight={"300px"}
      dialogTitleWidth={"300px"}
      dialogContentWidth={"60px"}
      subtitleSx={{ width: "350px", marginBottom: "10px" }}
    />
  );
};
